"use strict";
var ng2_popup_component_1 = require("./ng2-popup.component");
exports.Ng2PopupComponent = ng2_popup_component_1.Ng2PopupComponent;
var ng2_message_popup_component_1 = require("./ng2-message-popup.component");
exports.Ng2MessagePopupComponent = ng2_message_popup_component_1.Ng2MessagePopupComponent;
var ng2_popup_module_1 = require("./ng2-popup.module");
exports.Ng2PopupModule = ng2_popup_module_1.Ng2PopupModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-popup/dist/index.js
// module id = 47
// module chunks = 0